var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#B4A06E;}\r\n"),React.createElement("path",{"className":"st0","d":"M12.76,18.36l5.62-3.46l-5.62-3.25V18.36z M0,0v30h30V0H0z M24.66,21.07C23.13,23.11,15,23,15,23\r\n\ts-8.13,0.11-9.66-1.92C4.19,19.54,4.2,15,4.2,15s-0.01-4.54,1.14-6.07C6.87,6.89,15,7,15,7s8.13-0.11,9.66,1.92\r\n\tC25.81,10.46,25.8,15,25.8,15S25.81,19.54,24.66,21.07z","key":1})]);
}

Youtube.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30 30","style":{"enableBackground":"new 0 0 30 30"},"xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
